export var staticName = 'IntrospectionQuery';
export var introspectionQueryName = staticName;
//# sourceMappingURL=introspectionQueries.js.map